<template>
    <div class="budgetary-legitimation-document">

        <numeric-question v-model="sheets" :min="1">
            ¿Cuántas hojas tiene el documento?
        </numeric-question>

        <numeric-question v-if="sheets" v-model="whiteSheets" :min="0">
            ¿Cuántas caras en blanco tiene el documento?
        </numeric-question>

        <international-document v-if="whiteSheets !== null" ref="international" @updated="update"
                                :has-international-document.sync="hasInternationalDoc"></international-document>
        
    </div>
</template>

<script>
    export default {
        props: {
            singleSignature: Boolean,
        },

        mounted: function () {
            this.updateProgress();
        },

        data: function () {
            return {
                outsideCountry: null,

                sheets: null,
                whiteSheets: null,
                countries: {
                    haya: 0,
                    noHaya: 0
                },
                urgent: false
            }
        },

        computed: {
            costs: function () {
                return { cost: this.cost, untaxedCosts: this.untaxedCosts };
            },
            hasInternationalDoc: {
              set (value) {
              this.$emit('update:hasInternationalDocument', value)
            },
            get () {
              return this.hasInternationalDocument
            }
          }
        },

        methods: {
            update: function ( completed, {countries, urgent}) {
                this.countries = countries;
                this.urgent = urgent;

                this.completed = completed;
                this.$emit( 'updated', this.completed );
            },
            updateProgress: function () {
                if ( this.$parent.$options.name == 'accordion' ) {
                    this.$parent.$slots.title[1].elm.innerHTML = this.completed ? 'COMPLETADO' : 'FALTA COMPLETAR';
                    this.$parent.$slots.title[1].elm.className = this.completed ? 'text-success' : 'text-warning';
                }
            },
            getJSON: function () {
                return [
                    {
                        name: '¿Cuántas hojas tiene el documento?',
                        value: this.sheets
                    },
                    {
                        name: '¿Cuántas caras en blanco tiene el documento?',
                        value: this.whiteSheets
                    },
                    ...this.$refs.international.getJSON()
                ]
            }
        },

        watch: {
            sheets () {
                this.$emit( 'updated', this.completed );
            },
            whiteSheets () {
                this.$emit( 'updated', this.completed );
            }
        },

        components: {
            'international-document': require('./InternationalDocument.vue')
        }

    }
</script>

<style lang="scss">
    @import "../../../../sass/variables";

    .budgetary-numeric-question {
        //
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/testimonials/TestimonialsDocument.vue